/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

 import React, { useEffect } from "react"
 import PropTypes from "prop-types"
 import { useStaticQuery, graphql } from "gatsby"
 import { globalHistory } from "@reach/router"
 import Header from "../addon/header"
 import LayoutBreadcrumbs from "../addon/layoutBreadcrumbs"
 import Footer from "../addon/footer"
 
 const Layout = (props) => {
 const {
 children
 } = props
 useEffect(() => {
 return globalHistory.listen(({ action }) => {
 if (action === 'PUSH') {
 if (document.body.classList.contains("search_open")) {
 document.body.classList.remove("search_open")
 }
 if(typeof window.initCommon !== 'undefined') window.initCommon();
 }
 })
 }, [])
 const data = useStaticQuery(graphql`
 query SiteTitleQuery {
 site {
 siteMetadata {
 title
 }
 }
 }
 `)
 return (
     <>
     <Header siteTitle={data.site.siteMetadata?.title || `Title`} />
        <LayoutBreadcrumbs/>
        {children}
     <Footer/>
     </>
 )
 }
 Layout.propTypes = {
 children: PropTypes.node.isRequired,
 }

 export default Layout
